import { useScrollReveal } from '@/hooks/useScrollReveal';

const LegalProblem = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-problem-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-problem-h2">
          The fastest way to find your own precedent is to write it again.
        </h2>

        <div className="legal-passage mt-8">
          <p className="legal-body" data-testid="legal-problem-p1">
            You know you have written this before. You just can't find it, and looking takes longer than starting over. What you need to move a matter forward is spread across PDFs, email, intake forms, correspondence, notes, prior filings, folders, past matters, templates, and what you remember.
          </p>
          <p className="legal-body mt-6" data-testid="legal-problem-p2">
            A general AI chat window does not fix that. It adds one more place to paste things into, and a new set of questions. What is safe to upload. Whether the answer came from the actual file. Which document supported it. What was left out. Who reviewed it. What happened to the information afterward.
          </p>
          <p className="legal-body mt-6" data-testid="legal-problem-p3">
            Soundboard Matter works on the layer before generation. It shows where the matter stands, organizes what you have, makes the relevant sources retrievable, and only then brings AI in under conditions you set.
          </p>
          <p className="legal-body mt-6" data-testid="legal-problem-p4">
            It runs on your machine. Your files stay yours, and you are not renting them back one seat at a time.
          </p>
        </div>
      </div>
    </section>
  );
};

export default LegalProblem;
